import styled from 'styled-components'

const StyledCurrentPlan = styled.div`
  margin: 40px 0;

  .billing-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    font-family: ${({ theme }) => theme.fonts.lexend};

    .billing-subheader {
      color: ${({ theme }) => theme.colors.gray[700]};
      font-size: 20px;
      line-height: 32px;
      font-weight: 400;
    }

    .billing-button {
      color: ${({ theme }) => theme.colors.green[300]};
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 1px;
      border: 0;
      background: transparent;
      text-transform: uppercase;
    }
  }

  .current-plan-empty-state {
    font-family: ${({ theme }) => theme.fonts.nunito};
    text-align: center;

    padding: 30px;
    margin: 20px 0 40px 0;
    min-height: 150px;

    box-sizing: border-box;
    border-radius: 10px;
    background-color: rgba(235, 235, 235, 0.5);
    border: 1px solid #ebebeb;
  }

  .resubscribe {
    font-family: ${({ theme }) => theme.fonts.lexend};
    text-transform: uppercase;
    color: white;
    font-weight: 400;
    letter-spacing: 1px;

    padding: 14.5px 36px;
    margin: 28px auto 0 auto;
    background-color: ${({ theme }) => theme.colors.gray[900]};
    border: 1px solid ${({ theme }) => theme.colors.gray[700]};
    border-radius: 3px;
  }

  .restart-sub-wrap {
    border: 1px solid #c4c4c4;
    border-radius: 6px;
    padding: 28px;
    display: flex;
    align-items: center;
    flex-direction: column;

    .header-wrap {
      display: flex;
      justify-content: center;
      width: 100%;
      margin-bottom: 40px;

      .icon-wrap {
        background: ${({ theme }) => theme.colors.red[100]};
        border-radius: 3px;
        padding: 4px 4px 0 4px;
        height: fit-content;
        margin-right: 25px;
      }

      svg {
        width: 30px;
        height: auto;
      }
    }

    .title {
      font-family: ${({ theme }) => theme.fonts.nunito};
      font-weight: 700;
      font-size: 20px;
      color: ${({ theme }) => theme.colors.gray[700]};
      margin-bottom: 10px;
    }

    p,
    svg {
      color: ${({ theme }) => theme.colors.green[500]};
      font-weight: 500;
      font-size: 14px;
    }

    .button-wrap {
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }

  @media (min-width: 700px) {
    .restart-sub-wrap {
      flex-direction: row;

      .header-wrap {
        margin-bottom: 0px;
      }

      .button-wrap {
        justify-content: flex-end;
      }
    }
  }
`

export default StyledCurrentPlan
